import { useState } from 'react';

import InsightScreenshot, {
  type InsightScreenshotComment,
} from 'containers/admin/clients/client/tabs-components/insights-tab/insight-details/components/insight-screenshot';
import CommentsPanel from 'containers/admin/clients/client/tabs-components/insights-tab/insight-details/components/comments-panel';
import ContextDataPanel from 'containers/admin/clients/client/tabs-components/insights-tab/insight-details/components/context-data-panel/context-data-panel';

import type { InsightDto } from 'api/generated/schemas/insightDto';
import type { UserInsightDto } from 'api/generated/schemas/userInsightDto';

import Icons from 'assets/icons';

interface InsightDetailsTabProps {
  insight: (InsightDto | UserInsightDto) | null | undefined;
  comments?: InsightScreenshotComment[];
  commentsLoading: boolean;
  isAdminView?: boolean;
}

const InsightDetailsTab = ({
  insight,
  comments,
  commentsLoading,
  isAdminView = true,
}: InsightDetailsTabProps): React.JSX.Element => {
  const [selectedCommentId, setSelectedCommentId] = useState<
    string | number | null
  >(null);

  const handleCommentClick = (commentId: string | number): void => {
    setSelectedCommentId(commentId);
  };

  return (
    <div className="space-y-5">
      {insight?.description && (
        <div className="bg-blue-50 border border-blue-300 rounded-md p-5 mb-7">
          <div className="flex items-center gap-1 mb-1">
            <Icons.Idea customClass="size-4 text-blue-700" />

            <div className="text-lg font-semibold text-blue-700">Summary</div>
          </div>
          <p className="text-gray-700">{insight.description}</p>
        </div>
      )}

      <div className="flex gap-8">
        <div className="flex-1 space-y-4">
          <div className="border border-gray-200 rounded-lg p-4 h-full flex items-center justify-center">
            <InsightScreenshot
              imageUrl={insight?.imageUrl}
              comments={comments}
              selectedCommentId={selectedCommentId}
              onCommentClick={handleCommentClick}
            />
          </div>
        </div>

        <div className="w-1/3">
          <CommentsPanel
            comments={comments}
            loading={commentsLoading}
            selectedCommentId={selectedCommentId}
            onCommentClick={handleCommentClick}
          />
        </div>
      </div>
      <ContextDataPanel insight={insight} isAdminView={isAdminView} />
    </div>
  );
};

export default InsightDetailsTab;
